import React, { useEffect } from 'react';

const About = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="about-page">
            {/* Hero Section */}
            <section className="py-5 bg-dark text-white text-center">
                <div className="container py-5">
                    <h1 className="display-3 fw-bold mb-4">Protecting the Digital Frontier</h1>
                    <p className="lead mx-auto mb-0 max-w-[700px]">
                        Secure360 is committed to providing enterprise-grade security tools to businesses of all sizes,
                        ensuring a safer internet for everyone.
                    </p>
                </div>
            </section>

            {/* Mission Section */}
            <section className="py-5 bg-white">
                <div className="container py-5">
                    <div className="row align-items-center">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <h2 className="fw-bold mb-4">Our Mission</h2>
                            <p className="text-muted fs-5 mb-4">
                                In an era where cyber threats are evolving faster than ever, our mission is to democratize security.
                                We believe that every organization, whether a small startup or a large enterprise, deserves
                                access to high-quality security monitoring and vulnerability assessment tools.
                            </p>
                            <div className="row g-4">
                                <div className="col-sm-6">
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="las la-check-circle text-primary fs-3 me-2"></i>
                                        <h5 className="mb-0">Accessibility</h5>
                                    </div>
                                    <p className="small text-muted">Making security tools easy to use for everyone.</p>
                                </div>
                                <div className="col-sm-6">
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="las la-check-circle text-primary fs-3 me-2"></i>
                                        <h5 className="mb-0">Reliability</h5>
                                    </div>
                                    <p className="small text-muted">Providing accurate and timely security data.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="p-5 bg-light rounded-4">
                                <blockquote className="blockquote mb-0">
                                    <p className="fs-4 italic">"Security is not a product, but a process. Our goal is to be a partner in that process for every client we serve."</p>
                                    <footer className="blockquote-footer mt-3">Founder, Secure360</footer>
                                </blockquote>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Stats Section */}
            <section className="py-5 bg-primary text-white">
                <div className="container">
                    <div className="row text-center g-4">
                        <div className="col-md-3">
                            <h2 className="fw-bold mb-0">10k+</h2>
                            <p className="mb-0">Scans Performed</p>
                        </div>
                        <div className="col-md-3">
                            <h2 className="fw-bold mb-0">500+</h2>
                            <p className="mb-0">Happy Clients</p>
                        </div>
                        <div className="col-md-3">
                            <h2 className="fw-bold mb-0">1.2M</h2>
                            <p className="mb-0">Threats Blocked</p>
                        </div>
                        <div className="col-md-3">
                            <h2 className="fw-bold mb-0">99.9%</h2>
                            <p className="mb-0">Uptime Rate</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Values Section */}
            <section className="py-5 bg-light">
                <div className="container py-5">
                    <div className="text-center mb-5">
                        <h2 className="fw-bold">Our Core Values</h2>
                        <p className="text-muted">The principles that guide everything we do.</p>
                    </div>
                    <div className="row g-4">
                        {[
                            { title: 'Transparency', icon: 'la-eye', desc: 'We are open about how we work and how your data is protected.' },
                            { title: 'Innovation', icon: 'la-lightbulb', desc: 'We constantly updated our scanners with the latest threat intelligence.' },
                            { title: 'User-Centric', icon: 'la-user-check', desc: 'We build tools that are powerful yet intuitive to use.' },
                            { title: 'Integrity', icon: 'la-handshake', desc: 'We maintain the highest standards of ethics in security research.' }
                        ].map((value, idx) => (
                            <div className="col-md-3" key={idx}>
                                <div className="card border-0 shadow-sm h-100 p-4 text-center">
                                    <div className="mx-auto mb-3 text-primary text-[3rem]">
                                        <i className={`las ${value.icon}`}></i>
                                    </div>
                                    <h5 className="fw-bold">{value.title}</h5>
                                    <p className="text-muted small mb-0">{value.desc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default About;
